<template>
  <div class="d-flex justify-between filters my-2">
    <div class="flex pr-5">
      <v-text-field
        label="Name"
        dense
        outlined
        v-model="name"
        @change="$emit('update:name', $event)"
        @focus="name = ''"
        @blur="name == '' || name == null ? (name = ' ') : ''"
        append-icon="shopping_basket"
        hide-details
      >
      </v-text-field>
    </div>
    <div class="flex pr-5">
      <v-autocomplete
        :items="approveItems"
        v-model="approved"
        @change="$emit('update:approved', $event)"
        label="Approved"
        dense
        outlined
        append-icon="apartment"
        hide-details
      ></v-autocomplete>
    </div>
    <div class="flex pr-5">
      <v-autocomplete
        :items="activeItems"
        v-model="active"
        @change="$emit('update:active', $event)"
        label="Active"
        dense
        append-icon="tab"
        outlined
        hide-details
      ></v-autocomplete>
    </div>
    <div class="flex pr-5">
      <v-autocomplete
        :items="actions"
        label="Batch Action"
        append-icon="more_vert"
        class="action_button"
        :disabled="!action"
        :menu-props="{ bottom: true, offsetY: true }"
        dense
        outlined
        hide-details
      >
        <template v-slot:append-item>
          <v-divider></v-divider>
          <v-list class="py-0">
            <v-list-item-group>
              <v-list-item class="pointer">
                <v-list-item-content>
                  <v-list-item-title>
                    Delete
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </template>
      </v-autocomplete>
    </div>
    <div>
      <v-btn block color="primary" @click="$emit('apply')">Apply filters</v-btn>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    name: {
      type: String,
      default: null
    },
    approved: {
      type: Boolean,
      default: null
    },
    active: {
      type: Boolean,
      default: null
    },
    action: {
      type: Boolean,
      default: null
    }
  },
  data() {
    return {
      approveItems: [
        {
          text: "",
          value: null
        },
        {
          text: "true",
          value: 1
        },
        {
          text: "false",
          value: 0
        }
      ],
      activeItems: [
        {
          text: "",
          value: null
        },
        {
          text: "true",
          value: 1
        },
        {
          text: "false",
          value: 0
        }
      ],
      actions: []
    };
  }
};
</script>
